/* eslint-disable react/no-array-index-key */
import React, { lazy, Suspense, Fragment } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import DocsLayout from 'src/layouts/DocsLayout';
import MainLayout from 'src/layouts/MainLayout';
import HomeView from 'src/views/pages/HomeView';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/Guard/AuthGuard';
import GuestGuard from 'src/components/Guard/GuestGuard';
import AdminGuard from './components/Guard/AdminGuard';

import FireGuard from './components/Guard/FireGuard';
import AssessorGuard from './components/Guard/AssessorGuard';
import EngineeringGuard from './components/Guard/EngineeringGuard';
import MenroGuard from './components/Guard/MenroGuard';
import MaoGuard from './components/Guard/MaoGuard';
import MpdoGuard from './components/Guard/Mpdoguard';
import RhuGuard from './components/Guard/RhuGuard';
import PesoGuard from './components/Guard/PeroGuard';
import BarangayGuard from './components/Guard/BarangayGuard';
import BploGuard from './components/Guard/BploGuard';
import ModeratorGuard from './components/Guard/ModeratorGuard';
import AffiliateGuard from './components/Guard/AffiliateGuard';
import PermitEvaluatorGuard from './components/Guard/PermitEvaluatorGuard';
import PermitIssuanceGuard from './components/Guard/PermitIssuanceGuard';

const routesConfig = [
  {
    exact: true,
    path: '/',
    component: () => <Redirect to="/home" />
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/pages/Error404View'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView'))
  },

  {
    exact: true,
    guard: GuestGuard,
    path: '/login/external',
    component: lazy(() => import('src/views/auth/LoginView/ExternalLogin'))
  },

  {
    exact: true,
    path: '/login-unprotected',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/register',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/recover/password',
    component: lazy(() => import('src/views/auth/RecoverPasswordView'))
  },

  {
    exact: true,
    guard: GuestGuard,
    path: '/recover/password/reset-form/:email/:token',
    component: lazy(() =>
      import('src/views/auth/RecoverPasswordView/NewPasswordView/')
    )
  },

  {
    exact: true,
    path: '/register-unprotected',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },

  {
    path: '/app',
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/app',
        component: () => <Redirect to="/app/reports/dashboard" />
      },
      {
        exact: true,
        path: '/app/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/app/reports/dashboard',
        component: lazy(() => import('src/views/management/Companies'))
      },
      {
        exact: true,
        path: '/app/reports/dashboard-alternative',
        component: lazy(() =>
          import('src/views/reports/DashboardAlternativeView')
        )
      },
      {
        exact: true,
        path: '/app/reports',
        component: () => <Redirect to="/app/reports/dashboard" />
      },
      {
        exact: true,
        path: '/app/management/customers',
        component: lazy(() => import('src/views/management/CustomerListView'))
      },
      {
        exact: true,
        path: '/app/management/customers/:customerId',
        component: lazy(() =>
          import('src/views/management/CustomerDetailsView')
        )
      },
      {
        exact: true,
        path: '/app/management/customers/:customerId/edit',
        component: lazy(() => import('src/views/management/CustomerEditView'))
      },
      {
        exact: true,
        path: '/app/management/products',
        component: lazy(() => import('src/views/management/ProductListView'))
      },
      {
        exact: true,
        path: '/app/management/products/create',
        component: lazy(() => import('src/views/management/ProductCreateView'))
      },
      {
        exact: true,
        path: '/app/management/orders',
        component: lazy(() => import('src/views/management/OrderListView'))
      },
      {
        exact: true,
        path: '/app/management/orders/:orderId',
        component: lazy(() => import('src/views/management/OrderDetailsView'))
      },
      {
        exact: true,
        path: '/app/management/invoices',
        component: lazy(() => import('src/views/management/InvoiceListView'))
      },
      {
        exact: true,
        path: '/app/management/invoices/:invoiceId',
        component: lazy(() => import('src/views/management/InvoiceDetailsView'))
      },
      {
        exact: true,
        path: '/app/management',
        component: () => <Redirect to="/app/management/customers" />
      },
      {
        exact: true,
        path: '/app/management/companies',
        component: lazy(() => import('src/views/management/Companies'))
      },
      {
        exact: true,
        path: '/app/management/companies/create',
        component: lazy(() => import('src/views/management/Companies/Create'))
      },
      {
        exact: true,
        path: '/app/management/companies/payment/history',
        component: lazy(() => import('src/views/reports/DashboardView/history'))
      },
      {
        exact: true,
        path: '/app/management/companies/account/soa',
        component: lazy(() => import('src/views/reports/DashboardView/soa'))
      },
      {
        exact: true,
        path: '/app/management/companies/sentattachment/:type/:brgycode',
        component: lazy(() =>
          import('src/views/management/Companies/RequestRegistration')
        )
      },
      {
        exact: true,
        path: '/app/management/companies/edit/:company_code',
        component: lazy(() => import('src/views/management/Companies/Edit'))
      },

      // {
      //   exact: true,
      //   path: '/app/management/companies/assessment/details/currentdue/payment/notifications',
      //   component: lazy(() => import('src/views/management/Companies/Assessment/Details/SampleNotification'))
      // },
      {
        exact: true,
        path: '/app/management/companies/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },

      {
        exact: true,
        path: '/app/management/companies/assessment/:company_code',
        component: lazy(() =>
          import('src/views/management/Companies/Assessment')
        )
      },

      {
        exact: true,
        path:
          '/app/management/companies/assessment/request/requirements/sent/:assessment_id/:brgycode/:company_name',
        component: lazy(() =>
          import('src/views/management/Companies/Assessment/Requirements')
        )
      },
      {
        exact: true,
        path: '/app/management/companies/assessment/request/:company_code',
        component: lazy(() =>
          import('src/views/management/Companies/Assessment/Request')
        )
      },
      {
        exact: true,
        path:
          '/app/management/companies/assessment/details/:assessment_code/:company_code',
        component: lazy(() =>
          import('src/views/management/Companies/Assessment/Details')
        )
      },
      {
        exact: true,
        path:
          '/app/management/companies/assessment/details/paymentsuccessful/:assessment_code/:company_code',
        component: lazy(() =>
          import(
            'src/views/management/Companies/Assessment/Details/PaynamicPaymentSuccessful'
          )
        )
      },
      {
        exact: true,
        path:
          '/app/management/companies/assessment/details/currentdue/payments/gcash/redirect/failed',
        component: lazy(() =>
          import(
            'src/views/management/Companies/Assessment/Details/PaymentDialogGcashRedirectFailed'
          )
        )
      },
      // {
      //   exact: true,
      //   path:
      //     '/app/management/companies/assessment/edit/:assessment_code/:company_code',
      //   component: lazy(() =>
      //     import('src/views/management/Companies/Assessment/Edit')
      //   )
      // },
      {
        exact: true,
        path:
          '/app/management/companies/for-assessment/fees-details/print/:assessment_code',
        component: lazy(() =>
          import('src/views/pages/holdings/AssessmentPrintPage')
        )
      },

      // {
      //   exact: true,
      //   path: '/app/request/holdings/files/:company_code',
      //   component: lazy(() => import('src/views/reports/OfficesUploadFile'))
      // },

      {
        exact: true,
        path: '/app/request/holdings/files/:company_code/:assessment_code',
        component: lazy(() => import('src/views/reports/OfficesUploadFile'))
      },

      {
        exact: true,
        path: '/app/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      },
      // {
      //   exact: true,
      //   path: '/moderator/business-registratio',
      //   component: lazy(() => import('src/views/chat/Inquiries'))
      // },

      {
        exact: true,
        path: '/app/business/enrollments',
        component: lazy(() =>
          import('src/views/management/Companies/EnrollBusToUser')
        )
      },

      {
        exact: true,
        path: '/app/calendar',
        component: lazy(() => import('src/views/calendar/CalendarView'))
      },
      {
        exact: true,
        path: '/app/kanban',
        component: lazy(() => import('src/views/kanban/KanbanView'))
      },
      {
        exact: true,
        path: ['/app/chat/new', '/app/chat/:threadKey'],
        component: lazy(() => import('src/views/chat/ChatView'))
      },
      {
        exact: true,
        path: '/app/chat',
        component: () => <Redirect to="/app/chat/new" />
      },
      {
        exact: true,
        path: [
          '/app/mail/label/:customLabel/:mailId?',
          '/app/mail/:systemLabel/:mailId?'
        ],
        component: lazy(() => import('src/views/mail/MailView'))
      },
      {
        exact: true,
        path: '/app/mail',
        component: () => <Redirect to="/app/mail/all" />
      },
      {
        exact: true,
        path: '/app/projects/overview',
        component: lazy(() => import('src/views/projects/OverviewView'))
      },
      {
        exact: true,
        path: '/app/projects/browse',
        component: lazy(() => import('src/views/projects/ProjectBrowseView'))
      },
      {
        exact: true,
        path: '/app/projects/create',
        component: lazy(() => import('src/views/projects/ProjectCreateView'))
      },
      {
        exact: true,
        path: '/app/projects/:id',
        component: lazy(() => import('src/views/projects/ProjectDetailsView'))
      },
      {
        exact: true,
        path: '/app/projects',
        component: () => <Redirect to="/app/projects/browse" />
      },
      {
        exact: true,
        path: '/app/social/feed',
        component: lazy(() => import('src/views/social/FeedView'))
      },
      {
        exact: true,
        path: '/app/social/profile',
        component: lazy(() => import('src/views/social/ProfileView'))
      },
      {
        exact: true,
        path: '/app/social',
        component: () => <Redirect to="/app/social/profile" />
      },
      {
        exact: true,
        path: '/app/extra/charts/apex',
        component: lazy(() => import('src/views/extra/charts/ApexChartsView'))
      },
      {
        exact: true,
        path: '/app/extra/forms/formik',
        component: lazy(() => import('src/views/extra/forms/FormikView'))
      },
      {
        exact: true,
        path: '/app/extra/forms/redux',
        component: lazy(() => import('src/views/extra/forms/ReduxFormView'))
      },
      {
        exact: true,
        path: '/app/extra/editors/draft-js',
        component: lazy(() => import('src/views/extra/editors/DraftEditorView'))
      },
      {
        exact: true,
        path: '/app/extra/editors/quill',
        component: lazy(() => import('src/views/extra/editors/QuillEditorView'))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  {
    path: '/administrator',
    layout: DashboardLayout,
    guard: AdminGuard,
    routes: [
      {
        exact: true,
        path: '/administrator',
        component: () => <Redirect to="/administrator/dashboard" />
      },
      {
        exact: true,
        path: '/administrator/dashboard',
        component: lazy(() => import('src/views/reports/DashboardAdmin'))
      },
      {
        exact: true,
        path: '/administrator/email/sent',
        component: lazy(() => import('src/views/reports/DashboardAdmin/Email'))
      },
      {
        exact: true,
        path: '/administrator/request/clearances',
        component: lazy(() => import('src/views/reports/DashboardAdmin/Report'))
      },
      {
        exact: true,
        path: '/administrator/users',
        component: lazy(() => import('src/views/reports/DashboardAdmin/Users'))
      },
      {
        exact: true,
        path: '/administrator/requirements',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/Requirements')
        )
      },

      {
        exact: true,
        path: '/administrator/report/turnaround-time-tracker',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/TurnaroundTimeTracker')
        )
      }, 

      {
        exact: true,
        path: '/administrator/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },

      // olapp routes

      {
        exact: true,
        path: '/administrator/olapp/services',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/Olapp/services')
        )
      },

      {
        exact: true,
        path: '/administrator/olapp/services/steps/:serviceId',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/Olapp/services/steps')
        )
      },

      {
        exact: true,
        path: '/administrator/olapp/services/downloadable-forms/:serviceId',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardAdmin/Olapp/services/downloadable-forms'
          )
        )
      },

      {
        exact: true,
        path: '/administrator/olapp/services/fees/:serviceId',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/Olapp/services/fees')
        )
      },

      {
        exact: true,
        path: '/administrator/olapp/announcements',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/Olapp/announcements')
        )
      },

      {
        exact: true,
        path: '/administrator/olapp/requirements',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/Olapp/requrements')
        )
      },

      {
        exact: true,
        path: '/administrator/olapp/requirements/steps',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/Olapp/requirements-steps')
        )
      },

      {
        exact: true,
        path: '/administrator/olapp/requirements/list',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/Olapp/requrements/items')
        )
      },

      {
        exact: true,
        path: '/administrator/olapp/downloadable-forms',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/Olapp/downloadable-forms')
        )
      },

      {
        exact: true,
        path: '/administrator/report/paynamics/payment',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/Report/paynamics')
        )
      },

      {
        exact: true,
        path: '/administrator/report/registered/businesses',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/RegisteredBusinesses')
        )
      },

      {
        exact: true,
        path: '/administrator/report/index-of-payments',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/IndexOfPayments')
        )
      },

      {
        exact: true,
        path: '/administrator/report/index-of-payments/:busCode',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/IndexOfPayments/Report')
        )
      },

      {
        exact: true,
        path: '/administrator/report/closed-businesses',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/ClosedBusinesses')
        )
      },

      {
        exact: true,
        path: '/administrator/report/buscategory-per-account',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/BusCategoryPerAccount')
        )
      },
      {
        exact: true,
        path: '/administrator/report/summary-report',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/summary-report')
        )
      },

      {
        exact: true,
        path: '/administrator/report/summary-collection',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/summary-collection')
        )
      },

      {
        component: () => <Redirect to="/404" />
      }
    ]
  },

  // fire routes

  {
    path: '/fire',
    layout: DashboardLayout,
    guard: FireGuard,
    routes: [
      {
        exact: true,
        path: '/fire',
        component: () => <Redirect to="/fire/dashboard" />
      },
      {
        exact: true,
        path: '/fire/dashboard',
        component: lazy(() => import('src/views/reports/DashboardFire'))
      },
      {
        exact: true,
        path: '/fire/request/clearances',
        component: lazy(() => import('src/views/reports/DashboardFire/Report'))
      },
      {
        exact: true,
        path: '/fire/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/fire/request/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },
      {
        exact: true,
        path: '/fire/request/holdings/list',
        component: lazy(() => import('src/views/pages/holdings'))
      },

      {
        exact: true,
        path: '/fire/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      },

      {
        exact: true,
        path: '/fire/request/holdings/files/:company_code/:assessment_code',
        component: lazy(() => import('src/views/reports/OfficesUploadFile'))
      },
      {
        exact: true,
        path: '/fire/requirements',
        component: lazy(() => import('src/views/pages/Requirements'))
      },

      {
        exact: true,
        path: '/fire/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      }
    ]
  },

  // affiliate
  {
    path: '/affiliate',
    layout: DashboardLayout,
    guard: AffiliateGuard,
    routes: [
      {
        exact: true,
        path: '/affiliate',
        component: () => <Redirect to="/affiliate/dashboard" />
      },
      {
        exact: true,
        path: '/affiliate/dashboard',
        component: lazy(() => import('src/views/reports/DashboardAffeliate'))
      },

      {
        exact: true,
        path: '/affiliate/scanner/result/:qrcode',
        component: lazy(() =>
          import('src/views/reports/DashboardAffeliate/scanner/Result')
        )
      },

      {
        exact: true,
        path: '/affiliate/assessment/request/permit/scan-details/:assessment_code',
        component: lazy(() => import('src/views/reports/DashboardAffeliate/details'))
      },

      {
        exact: true,
        path: '/affiliate/assessment/request/view-assessment/:assessment_code',
        component: lazy(() =>
          import('src/views/reports/DashboardAffeliate/assessment')
        )
      },

      {
        exact: true,
        path: '/affiliate/assessment/request/permit/:assessment_code',
        component: lazy(() => import('src/views/pages/holdings/MayorsPermit'))
      }
    ]
  },

  // assessor routes
  {
    path: '/assessor',
    layout: DashboardLayout,
    guard: AssessorGuard,
    routes: [
      {
        exact: true,
        path: '/assessor',
        component: () => <Redirect to="/assessor/dashboard" />
      },
      {
        exact: true,
        path: '/assessor/dashboard',
        component: lazy(() => import('src/views/reports/DashboardAssessor'))
      },
      {
        exact: true,
        path: '/assessor/request/clearances',
        component: lazy(() =>
          import('src/views/reports/DashboardAssessor/Report')
        )
      },
      {
        exact: true,
        path: '/assessor/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/assessor/request/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },
      {
        exact: true,
        path: '/assessor/request/holdings/list',
        component: lazy(() => import('src/views/pages/holdings'))
      },
      {
        exact: true,
        path: '/assessor/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      },

      {
        exact: true,
        path: '/assessor/request/holdings/files/:company_code/:assessment_code',
        component: lazy(() => import('src/views/reports/OfficesUploadFile'))
      },
      {
        exact: true,
        path: '/assessor/requirements',
        component: lazy(() => import('src/views/pages/Requirements'))
      },
      {
        exact: true,
        path: '/assessor/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      }
    ]
  },

  // engineering routes
  {
    path: '/engineering',
    layout: DashboardLayout,
    guard: EngineeringGuard,
    routes: [
      {
        exact: true,
        path: '/engineering',
        component: () => <Redirect to="/engineering/dashboard" />
      },
      {
        exact: true,
        path: '/engineering/dashboard',
        component: lazy(() => import('src/views/reports/DashboardEngineer'))
      },
      {
        exact: true,
        path: '/engineering/request/clearances',
        component: lazy(() =>
          import('src/views/reports/DashboardEngineer/Report')
        )
      },
      {
        exact: true,
        path: '/engineering/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/engineering/request/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },
      {
        exact: true,
        path: '/engineering/request/holdings/list',
        component: lazy(() => import('src/views/pages/holdings'))
      },
      {
        exact: true,
        path: '/engineering/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      },
      {
        exact: true,
        path: '/engineering/requirements',
        component: lazy(() => import('src/views/pages/Requirements'))
      },
      {
        exact: true,
        path: '/engineering/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      }
    ]
  },

  // menro routes
  {
    path: '/menro',
    layout: DashboardLayout,
    guard: MenroGuard,
    routes: [
      {
        exact: true,
        path: '/menro',
        component: () => <Redirect to="/menro/dashboard" />
      },
      {
        exact: true,
        path: '/menro/dashboard',
        component: lazy(() => import('src/views/reports/DashboardMenro'))
      },
      {
        exact: true,
        path: '/menro/request/clearances',
        component: lazy(() => import('src/views/reports/DashboardMenro/Report'))
      },
      {
        exact: true,
        path: '/menro/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/menro/request/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },
      {
        exact: true,
        path: '/menro/request/holdings/list',
        component: lazy(() => import('src/views/pages/holdings'))
      },
      {
        exact: true,
        path: '/menro/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      },

      {
        exact: true,
        path: '/menro/request/holdings/files/:company_code/:assessment_code',
        component: lazy(() => import('src/views/reports/OfficesUploadFile'))
      },

      {
        exact: true,
        path: '/menro/requirements',
        component: lazy(() => import('src/views/pages/Requirements'))
      },
      {
        exact: true,
        path: '/menro/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      }
    ]
  },

  // mao routes
  {
    path: '/mao',
    layout: DashboardLayout,
    guard: MaoGuard,
    routes: [
      {
        exact: true,
        path: '/mao',
        component: () => <Redirect to="/mao/dashboard" />
      },
      {
        exact: true,
        path: '/mao/dashboard',
        component: lazy(() => import('src/views/reports/DashboardMao'))
      },
      {
        exact: true,
        path: '/mao/request/clearances',
        component: lazy(() => import('src/views/reports/DashboardMao/Report'))
      },
      {
        exact: true,
        path: '/mao/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/mao/request/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },
      {
        exact: true,
        path: '/mao/request/holdings/list',
        component: lazy(() => import('src/views/pages/holdings'))
      },
      {
        exact: true,
        path: '/mao/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      },

      {
        exact: true,
        path: '/mao/request/holdings/files/:company_code/:assessment_code',
        component: lazy(() => import('src/views/reports/OfficesUploadFile'))
      },
      {
        exact: true,
        path: '/mao/requirements',
        component: lazy(() => import('src/views/pages/Requirements'))
      },
      {
        exact: true,
        path: '/mao/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      }
    ]
  },

  // mpdo routes
  {
    path: '/mpdo',
    layout: DashboardLayout,
    guard: MpdoGuard,
    routes: [
      {
        exact: true,
        path: '/mpdo',
        component: () => <Redirect to="/mpdo/dashboard" />
      },
      {
        exact: true,
        path: '/mpdo/dashboard',
        component: lazy(() => import('src/views/reports/DashboardMpdo'))
      },
      {
        exact: true,
        path: '/mpdo/request/clearances',
        component: lazy(() => import('src/views/reports/DashboardMpdo/Report'))
      },
      {
        exact: true,
        path: '/mpdo/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/mpdo/request/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },

      {
        exact: true,
        path: '/mpdo/request/holdings/list',
        component: lazy(() => import('src/views/pages/holdings'))
      },
      {
        exact: true,
        path: '/mpdo/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      },
      {
        exact: true,
        path: '/mpdo/request/holdings/files/:company_code/:assessment_code',
        component: lazy(() => import('src/views/reports/OfficesUploadFile'))
      },
      {
        exact: true,
        path: '/mpdo/requirements',
        component: lazy(() => import('src/views/pages/Requirements'))
      },
      {
        exact: true,
        path: '/mpdo/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      }
    ]
  },

  // rhu routes
  {
    path: '/rhu',
    layout: DashboardLayout,
    guard: RhuGuard,
    routes: [
      {
        exact: true,
        path: '/rhu',
        component: () => <Redirect to="/rhu/dashboard" />
      },
      {
        exact: true,
        path: '/rhu/dashboard',
        component: lazy(() => import('src/views/reports/DashboardRhu'))
      },
      {
        exact: true,
        path: '/rhu/request/clearances',
        component: lazy(() => import('src/views/reports/DashboardRhu/Report'))
      },
      {
        exact: true,
        path: '/rhu/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/rhu/request/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },
      {
        exact: true,
        path: '/rhu/request/holdings/list',
        component: lazy(() => import('src/views/pages/holdings'))
      },
      {
        exact: true,
        path: '/rhu/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      },
      {
        exact: true,
        path: '/rhu/request/holdings/files/:company_code/:assessment_code',
        component: lazy(() => import('src/views/reports/OfficesUploadFile'))
      },
      {
        exact: true,
        path: '/rhu/requirements',
        component: lazy(() => import('src/views/pages/Requirements'))
      },
      {
        exact: true,
        path: '/rhu/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      }
    ]
  },

  // peso routes
  {
    path: '/peso',
    layout: DashboardLayout,
    guard: PesoGuard,
    routes: [
      {
        exact: true,
        path: '/peso',
        component: () => <Redirect to="/peso/dashboard" />
      },
      {
        exact: true,
        path: '/peso/dashboard',
        component: lazy(() => import('src/views/reports/DashboardPeso'))
      },
      {
        exact: true,
        path: '/peso/request/clearances',
        component: lazy(() => import('src/views/reports/DashboardPeso/Report'))
      },
      {
        exact: true,
        path: '/peso/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/peso/request/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },
      {
        exact: true,
        path: '/peso/request/holdings/list',
        component: lazy(() => import('src/views/pages/holdings'))
      },
      {
        exact: true,
        path: '/peso/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      },
      {
        exact: true,
        path: '/peso/request/holdings/files/:company_code/:assessment_code',
        component: lazy(() => import('src/views/reports/OfficesUploadFile'))
      },
      {
        exact: true,
        path: '/peso/requirements',
        component: lazy(() => import('src/views/pages/Requirements'))
      }
    ]
  },

  // barangay routes
  {
    path: '/barangay',
    layout: DashboardLayout,
    guard: BarangayGuard,
    routes: [
      {
        exact: true,
        path: '/barangay',
        component: () => <Redirect to="/barangay/dashboard" />
      },
      {
        exact: true,
        path: '/barangay/dashboard',
        component: lazy(() => import('src/views/reports/DashboardBarangay'))
      },
      {
        exact: true,
        path: '/barangay/request/clearances',
        component: lazy(() =>
          import('src/views/reports/DashboardBarangay/Report')
        )
      },
      {
        exact: true,
        path: '/barangay/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/barangay/request/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },
      {
        exact: true,
        path: '/barangay/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      },

      {
        exact: true,
        path: '/barangay/request/holdings/files/:company_code/:assessment_code',
        component: lazy(() => import('src/views/reports/OfficesUploadFile'))
      },
      {
        exact: true,
        path: '/barangay/requirements',
        component: lazy(() => import('src/views/pages/Requirements'))
      }
    ]
  },

  // bplo routes

  {
    path: '/bplo',
    layout: DashboardLayout,
    guard: BploGuard,
    routes: [
      {
        exact: true,
        path: '/bplo',
        component: () => <Redirect to="/bplo/dashboard" />
      },
      {
        exact: true,
        path: '/bplo/dashboard',
        component: lazy(() => import('src/views/reports/DashboardBplo'))
      },
      {
        exact: true,
        path: '/bplo/request/clearances',
        component: lazy(() => import('src/views/reports/DashboardBplo/Report'))
      },
      {
        exact: true,
        path: '/bplo/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/bplo/request/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },

      {
        exact: true,
        path: '/bplo/request/holdings/list',
        component: lazy(() =>
          import('src/views/reports/DashboardBplo/holdings')
        )
      },

      {
        exact: true,
        path: '/bplo/companies/edit/:company_code',
        component: lazy(() =>
          import('src/views/reports/DashboardBplo/holdings/edit')
        )
      },

      {
        exact: true,
        path: '/bplo/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      },
      {
        exact: true,
        path: '/bplo/request/holdings/files/:company_code/:assessment_code',
        component: lazy(() => import('src/views/reports/OfficesUploadFile'))
      },

      {
        exact: true,
        path: '/bplo/companies',
        component: lazy(() =>
          import('src/views/reports/DashboardModerator/companies')
        )
      },
      {
        exact: true,
        path: '/bplo/requirements',
        component: lazy(() => import('src/views/pages/Requirements'))
      },

      // reports
      {
        exact: true,
        path: '/bplo/report/registered/businesses',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/RegisteredBusinesses')
        )
      },

      {
        exact: true,
        path: '/bplo/report/index-of-payments',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/IndexOfPayments')
        )
      },

      {
        exact: true,
        path: '/bplo/report/index-of-payments/:busCode',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/IndexOfPayments/Report')
        )
      },

      {
        exact: true,
        path: '/bplo/report/closed-businesses',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/ClosedBusinesses')
        )
      },

      {
        exact: true,
        path: '/bplo/report/buscategory-per-account',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/BusCategoryPerAccount')
        )
      },
      {
        exact: true,
        path: '/bplo/report/summary-report',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/summary-report')
        )
      },

      {
        exact: true,
        path: '/bplo/report/summary-collection',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/summary-collection')
        )
      }
    ]
  },

  // moderator routes
  {
    path: '/moderator',
    layout: DashboardLayout,
    guard: ModeratorGuard,
    routes: [
      {
        exact: true,
        path: '/moderator',
        component: () => <Redirect to="/moderator/dashboard" />
      },
      {
        exact: true,
        path: '/moderator/dashboard',
        component: lazy(() => import('src/views/reports/DashboardModerator'))
      },

      {
        exact: true,
        path: '/moderator/for-sworn/details/:requestId',
        component: lazy(() =>
          import('src/views/reports/DashboardModerator/for-sworn/details')
        )
      },

      {
        exact: true,
        path: '/moderator/for-sworn/approved-details/:requestId',
        component: lazy(() =>
          import('src/views/reports/DashboardModerator/approved-sworn/details')
        )
      },

      {
        exact: true,
        path: '/moderator/for-assessment/assess/:swornId',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardModerator/for-assessment/details/for-assess'
          )
        )
      },

      {
        exact: true,
        path:
          '/moderator/for-assessment/assess/add-fees/:swornId/:busCategoryCode/:transactionType/:amount',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardModerator/for-assessment/details/add-fees'
          )
        )
      },

      {
        exact: true,
        path: '/moderator/for-assessment',
        component: lazy(() =>
          import('src/views/reports/DashboardModerator/for-assessment')
        )
      },

      {
        exact: true,
        path:
          '/moderator/companies/assessment/requirements/:busCode/:assessmentId',
        component: lazy(() =>
          import('src/views/reports/DashboardModerator/Requirements/ByOffice')
        )
      },

      {
        exact: true,
        path: '/moderator/for-assessment/fees-details/:assessment_code',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardModerator/for-assessment/details/FeesDetails'
          )
        )
      },

      {
        exact: true,
        path: '/moderator/for-assessment/fees-details/print/:assessment_code',
        component: lazy(() =>
          import('src/views/pages/holdings/AssessmentPrintPage')
        )
      },

      {
        exact: true,
        path: '/moderator/business-type',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardModerator/References/business-type'
          )
        )
      },

      {
        exact: true,
        path: '/moderator/business-category',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardModerator/References/business-category'
          )
        )
      },

      {
        exact: true,
        path: '/moderator/office',
        component: lazy(() =>
          import('src/views/reports/DashboardModerator/References/office')
        )
      },

      {
        exact: true,
        path: '/moderator/barangay',
        component: lazy(() =>
          import('src/views/reports/DashboardModerator/References/barangay')
        )
      },

      {
        exact: true,
        path: '/moderator/fees-account',
        component: lazy(() =>
          import('src/views/reports/DashboardModerator/References/fees-account')
        )
      },

      {
        exact: true,
        path: '/moderator/fees-template',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardModerator/References/fees-template'
          )
        )
      },

      {
        exact: true,
        path: '/moderator/companies',
        component: lazy(() =>
          import('src/views/reports/DashboardModerator/companies')
        )
      },

      {
        exact: true,
        path: '/moderator/companies/new',
        component: lazy(() =>
          import('src/views/reports/DashboardModerator/companies/new')
        )
      },

      {
        exact: true,
        path: '/moderator/request/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },

      {
        exact: true,
        path: '/moderator/companies/edit/:company_code',
        component: lazy(() =>
          import('src/views/reports/DashboardModerator/companies/edit')
        )
      },
      {
        exact: true,
        path: '/moderator/assessment/request/permit/:assessment_code',
        component: lazy(() => import('src/views/pages/holdings/MayorsPermit'))
      },

      {
        exact: true,
        path: '/moderator/business-registration',
        component: lazy(() =>
          import('src/views/reports/DashboardModerator/business-registration')
        )
      },

      {
        exact: true,
        path:
          '/moderator/request/holdings/files/:company_code/:assessment_code',
        component: lazy(() => import('src/views/reports/OfficesUploadFile'))
      },

      {
        exact: true,
        path: '/moderator/requirements',
        component: lazy(() => import('src/views/pages/Requirements'))
      },

      // reports
      {
        exact: true,
        path: '/moderator/report/registered/businesses',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/RegisteredBusinesses')
        )
      },

      {
        exact: true,
        path: '/moderator/report/index-of-payments',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/IndexOfPayments')
        )
      },

      {
        exact: true,
        path: '/moderator/report/index-of-payments/:busCode',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/IndexOfPayments/Report')
        )
      },

      {
        exact: true,
        path: '/moderator/report/closed-businesses',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/ClosedBusinesses')
        )
      },

      {
        exact: true,
        path: '/moderator/report/buscategory-per-account',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/BusCategoryPerAccount')
        )
      },
      {
        exact: true,
        path: '/moderator/report/summary-report',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/summary-report')
        )
      },

      {
        exact: true,
        path: '/moderator/report/summary-collection',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/summary-collection')
        )
      },

      {
        exact: true,
        path: '/moderator/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },

      {
        exact: true,
        path: '/moderator/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      },

      {
        exact: true,
        path: '/moderator/rollback-assessment',
        component: lazy(() =>
          import('src/views/reports/DashboardModerator/rollback-assessment')
        )
      }
    ]
  },

  // permit evaluator routes
  {
    path: '/permit-evaluator',
    layout: DashboardLayout,
    guard: PermitEvaluatorGuard,
    routes: [
      {
        exact: true,
        path: '/permit-evaluator',
        component: () => <Redirect to="/permit-evaluator/dashboard" />
      },
      {
        exact: true,
        path: '/permit-evaluator/dashboard',
        component: lazy(() =>
          import('src/views/reports/DashboardPermitEvaluator')
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/for-sworn/details/:requestId',
        component: lazy(() =>
          import('src/views/reports/DashboardPermitEvaluator/for-sworn/details')
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/for-sworn/approved-details/:requestId',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardPermitEvaluator/approved-sworn/details'
          )
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/for-assessment/assess/:swornId',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardPermitEvaluator/for-assessment/details/for-assess'
          )
        )
      },

      {
        exact: true,
        path:
          '/permit-evaluator/for-assessment/assess/add-fees/:swornId/:busCategoryCode/:transactionType/:amount',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardPermitEvaluator/for-assessment/details/add-fees'
          )
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/for-assessment',
        component: lazy(() =>
          import('src/views/reports/DashboardPermitEvaluator/for-assessment')
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/for-assessment/fees-details/:assessment_code',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardPermitEvaluator/for-assessment/details/FeesDetails'
          )
        )
      },

      {
        exact: true,
        path:
          '/permit-evaluator/for-assessment/fees-details/print/:assessment_code',
        component: lazy(() =>
          import('src/views/pages/holdings/AssessmentPrintPage')
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/request/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },

      {
        exact: true,
        path: '/permit-evaluator/assessment/request/permit/:assessment_code',
        component: lazy(() => import('src/views/pages/holdings/MayorsPermit'))
      },

      {
        exact: true,
        path: '/permit-evaluator/business-registration',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardPermitEvaluator/business-registration'
          )
        )
      },

      {
        exact: true,
        path:
          '/permit-evaluator/companies/assessment/requirements/:busCode/:assessmentId',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardPermitEvaluator/Requirements/ByOffice'
          )
        )
      },

      {
        exact: true,
        path:
          '/permit-evaluator/request/holdings/files/:company_code/:assessment_code',
        component: lazy(() => import('src/views/reports/OfficesUploadFile'))
      },

      {
        exact: true,
        path: '/permit-evaluator/requirements',
        component: lazy(() => import('src/views/pages/Requirements'))
      },

      // reports
      {
        exact: true,
        path: '/permit-evaluator/report/registered/businesses',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/RegisteredBusinesses')
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/report/index-of-payments',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/IndexOfPayments')
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/report/index-of-payments/:busCode',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/IndexOfPayments/Report')
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/report/closed-businesses',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/ClosedBusinesses')
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/report/buscategory-per-account',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/BusCategoryPerAccount')
        )
      },
      {
        exact: true,
        path: '/permit-evaluator/report/summary-report',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/summary-report')
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/report/summary-collection',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/summary-collection')
        )
      },
      {
        exact: true,
        path: '/permit-evaluator/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },

      {
        exact: true,
        path: '/permit-evaluator/companies',
        component: lazy(() =>
          import('src/views/reports/DashboardPermitEvaluator/companies')
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/companies/edit/:company_code',
        component: lazy(() =>
          import('src/views/reports/DashboardPermitEvaluator/companies/edit')
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/companies/new',
        component: lazy(() =>
          import('src/views/reports/DashboardPermitEvaluator/companies/new')
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/rollback-assessment',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardPermitEvaluator/rollback-assessment'
          )
        )
      }
    ]
  },

  // permit issuance routes
  {
    path: '/permit-issuance',
    layout: DashboardLayout,
    guard: PermitIssuanceGuard,
    routes: [
      {
        exact: true,
        path: '/permit-issuance',
        component: () => <Redirect to="/permit-issuance/dashboard" />
      },
      {
        exact: true,
        path: '/permit-issuance/dashboard',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardPermitIssuance/for-assessment/index'
          )
        )
      },

      {
        exact: true,
        path: '/permit-issuance/for-assessment/assess/:swornId',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardPermitIssuance/for-assessment/details/for-assess'
          )
        )
      },

      {
        exact: true,
        path:
          '/permit-issuance/for-assessment/assess/add-fees/:swornId/:busCategoryCode/:transactionType/:amount',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardPermitIssuance/for-assessment/details/add-fees'
          )
        )
      },

      {
        exact: true,
        path: '/permit-issuance/for-assessment',
        component: lazy(() =>
          import('src/views/reports/DashboardPermitIssuance/for-assessment')
        )
      },

      {
        exact: true,
        path: '/permit-issuance/for-assessment/fees-details/:assessment_code',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardPermitIssuance/for-assessment/details/FeesDetails'
          )
        )
      },

      {
        exact: true,
        path:
          '/permit-issuance/for-assessment/fees-details/print/:assessment_code',
        component: lazy(() =>
          import('src/views/pages/holdings/AssessmentPrintPage')
        )
      },

      {
        exact: true,
        path: '/permit-issuance/request/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },

      {
        exact: true,
        path: '/permit-issuance/assessment/request/permit/:assessment_code',
        component: lazy(() => import('src/views/pages/holdings/MayorsPermit'))
      },

      {
        exact: true,
        path:
          '/permit-issuance/companies/assessment/requirements/:busCode/:assessmentId',
        component: lazy(() =>
          import(
            'src/views/reports/DashboardPermitIssuance/Requirements/ByOffice'
          )
        )
      },

      {
        exact: true,
        path:
          '/permit-issuance/request/holdings/files/:company_code/:assessment_code',
        component: lazy(() => import('src/views/reports/OfficesUploadFile'))
      },

      {
        exact: true,
        path: '/permit-issuance/companies',
        component: lazy(() =>
          import('src/views/reports/DashboardModerator/companies')
        )
      },

      {
        exact: true,
        path: '/permit-issuance/requirements',
        component: lazy(() => import('src/views/pages/Requirements'))
      },

      // reports
      {
        exact: true,
        path: '/permit-issuance/report/registered/businesses',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/RegisteredBusinesses')
        )
      },

      {
        exact: true,
        path: '/permit-evaluator/report/index-of-payments',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/IndexOfPayments')
        )
      },

      {
        exact: true,
        path: '/permit-issuance/report/index-of-payments',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/IndexOfPayments')
        )
      },

      {
        exact: true,
        path: '/permit-issuance/report/index-of-payments/:busCode',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/IndexOfPayments/Report')
        )
      },

      {
        exact: true,
        path: '/permit-issuance/report/closed-businesses',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/ClosedBusinesses')
        )
      },

      {
        exact: true,
        path: '/permit-issuance/report/buscategory-per-account',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/BusCategoryPerAccount')
        )
      },
      {
        exact: true,
        path: '/permit-issuance/report/summary-report',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/summary-report')
        )
      },

      {
        exact: true,
        path: '/permit-issuance/report/summary-collection',
        component: lazy(() =>
          import('src/views/reports/DashboardAdmin/summary-collection')
        )
      },
      {
        exact: true,
        path: '/permit-issuance/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },

      {
        exact: true,
        path: '/permit-issuance/inquiry',
        component: lazy(() => import('src/views/chat/Inquiries'))
      }
    ]
  },

  {
    path: '/docs',
    layout: DocsLayout,
    routes: [
      {
        exact: true,
        path: '/docs',
        component: () => <Redirect to="/docs/welcome" />
      },
      {
        exact: true,
        path: '/docs/welcome',
        component: lazy(() => import('src/views/docs/WelcomeView'))
      },
      {
        exact: true,
        path: '/docs/getting-started',
        component: lazy(() => import('src/views/docs/GettingStartedView'))
      },
      {
        exact: true,
        path: '/docs/environment-variables',
        component: lazy(() => import('src/views/docs/EnvironmentVariablesView'))
      },
      {
        exact: true,
        path: '/docs/deployment',
        component: lazy(() => import('src/views/docs/DeploymentView'))
      },
      {
        exact: true,
        path: '/docs/api-calls',
        component: lazy(() => import('src/views/docs/ApiCallsView'))
      },
      {
        exact: true,
        path: '/docs/analytics',
        component: lazy(() => import('src/views/docs/AnalyticsView'))
      },
      {
        exact: true,
        path: '/docs/authentication',
        component: lazy(() => import('src/views/docs/AuthenticationView'))
      },
      {
        exact: true,
        path: '/docs/routing',
        component: lazy(() => import('src/views/docs/RoutingView'))
      },
      {
        exact: true,
        path: '/docs/settings',
        component: lazy(() => import('src/views/docs/SettingsView'))
      },
      {
        exact: true,
        path: '/docs/state-management',
        component: lazy(() => import('src/views/docs/StateManagementView'))
      },
      {
        exact: true,
        path: '/docs/theming',
        component: lazy(() => import('src/views/docs/ThemingView'))
      },
      {
        exact: true,
        path: '/docs/support',
        component: lazy(() => import('src/views/docs/SupportView'))
      },
      {
        exact: true,
        path: '/docs/changelog',
        component: lazy(() => import('src/views/docs/ChangelogView'))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  {
    path: '*',
    layout: MainLayout,
    routes: [
      {
        exact: true,
        path: '/home',
        component: HomeView
      },
      {
        exact: true,
        path: '/pricing',
        component: lazy(() => import('src/views/pages/PricingView'))
      },

      {
        exact: true,
        path: '/home/terms-and-conditions',
        component: lazy(() => import('src/views/pages/TermsAndConditions'))
      },

      // olapp panamics redirects
      {
        exact: true,
        path: '/olapp/paynamics/redirects/success',
        component: lazy(() =>
          import(
            'src/views/pages/ulap/paynamics/redirects/PaymentDialogGcashRedirectSuccess'
          )
        )
      },

      {
        exact: true,
        path: '/olapp/paynamics/redirects/failed',
        component: lazy(() =>
          import(
            'src/views/pages/ulap/paynamics/redirects/PaymentDialogGcashRedirectFailed'
          )
        )
      },

      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  //** ebps routes **//

  {
    path: '/ebps',
    // layout: '',
    routes: [
      {
        exact: true,
        path: '/registration'
        // component: lazy(() => import('src/ebps/users/Registration'))
      },
      {
        exact: true,
        path: '/ebps/login',
        // layout: MainLayout,
        component: lazy(() => import('src/views/auth/LoginView'))
      }
    ]
  }
];

const renderRoutes = routes =>
  routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, i) => {
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Component = route.component;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={props => (
                <Guard>
                  <Layout>
                    {route.routes ? (
                      renderRoutes(route.routes)
                    ) : (
                      <Component {...props} />
                    )}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  ) : null;

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
